import React, { useCallback, useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon, CheckCircleIcon } from 'lucide-react';
const FIRST_NAMES = ['María', 'Juan', 'Lucía', 'Carlos', 'Ana', 'Pedro', 'Valentina', 'Diego', 'Camila', 'Martín', 'Sofía', 'Alejandro', 'Florencia', 'Matías', 'Carolina', 'Federico'];
const LAST_NAMES = ['González', 'Rodríguez', 'López', 'Martínez', 'García', 'Fernández', 'Pérez', 'Sánchez', 'Romero', 'Díaz', 'Torres', 'Álvarez', 'Ruiz', 'Ramírez'];
const PROVINCES = ['Buenos Aires', 'Córdoba', 'Santa Fe', 'Mendoza', 'Tucumán', 'Entre Ríos', 'Salta', 'Misiones', 'Chaco', 'San Juan', 'Jujuy', 'Río Negro', 'Neuquén', 'La Pampa', 'Catamarca', 'San Luis', 'Formosa', 'Santiago del Estero'];
function pickRandom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
function generateNotification() {
  const firstName = pickRandom(FIRST_NAMES);
  const lastName = pickRandom(LAST_NAMES);
  const province = pickRandom(PROVINCES);
  const minutes = Math.floor(Math.random() * 14) + 1;
  return {
    firstName,
    lastName,
    province,
    minutes
  };
}
type Notification = ReturnType<typeof generateNotification>;
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [exiting, setExiting] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [current, setCurrent] = useState<Notification | null>(null);
  const showNext = useCallback(() => {
    setCurrent(generateNotification());
    setExiting(false);
    setVisible(true);
  }, []);
  const hideNotification = useCallback(() => {
    setExiting(true);
    setTimeout(() => {
      setVisible(false);
      setExiting(false);
    }, 400);
  }, []);
  useEffect(() => {
    if (dismissed) return;
    const initialTimer = setTimeout(() => {
      showNext();
    }, 3000);
    return () => clearTimeout(initialTimer);
  }, [dismissed, showNext]);
  useEffect(() => {
    if (dismissed || !visible || exiting) return;
    const hideTimer = setTimeout(() => {
      hideNotification();
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, exiting, dismissed, hideNotification]);
  useEffect(() => {
    if (dismissed || visible || !current) return;
    const nextDelay = 3000 + Math.random() * 1000;
    const nextTimer = setTimeout(() => {
      showNext();
    }, nextDelay);
    return () => clearTimeout(nextTimer);
  }, [visible, dismissed, current, showNext]);
  if (dismissed || !visible || !current) return null;
  return <div className={`fixed bottom-6 left-6 z-50 max-w-xs w-full ${exiting ? 'popup-exit' : 'popup-enter'}`} role="status" aria-live="polite" data-id="element-224">
      <div className="bg-gray-900 border border-pink-500/30 rounded-xl shadow-2xl shadow-black/40 p-4 flex items-start gap-3" data-id="element-225">
        {/* Icon */}
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-pink-500/20 flex items-center justify-center relative" data-id="element-226">
          <ShoppingBagIcon className="w-5 h-5 text-pink-400" data-id="element-227" />
          <CheckCircleIcon className="w-4 h-4 text-green-400 absolute -bottom-0.5 -right-0.5 fill-gray-900" data-id="element-228" />
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0" data-id="element-229">
          <p className="text-sm text-white leading-snug" data-id="element-230">
            <span className="font-semibold text-pink-300" data-id="element-231">
              {current.firstName} {current.lastName}
            </span>{' '}
            <span className="text-gray-300" data-id="element-232">de</span>{' '}
            <span className="font-medium text-white" data-id="element-233">{current.province}</span>{' '}
            <span className="text-gray-300" data-id="element-234">adquirió el</span>{' '}
            <span className="font-semibold text-pink-400" data-id="element-235">MegaPack Danza</span>
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-236">
            Hace {current.minutes}{' '}
            {current.minutes === 1 ? 'minuto' : 'minutos'}
          </p>
        </div>

        {/* Close */}
        <button onClick={() => setDismissed(true)} className="flex-shrink-0 text-gray-500 hover:text-gray-300 transition-colors p-0.5 rounded" aria-label="Cerrar notificación" data-id="element-237">
          <XIcon className="w-4 h-4" data-id="element-238" />
        </button>
      </div>
    </div>;
}